var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBg8Desktop({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1400,
    height: 400,
    viewBox: "0 0 1400 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_454_108729)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_454_108729)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 291.33,
    cy: 425.387,
    rx: 291.33,
    ry: 425.387,
    transform: "matrix(0.697674 0.716415 -0.683113 0.730313 1203.05 -210.996)",
    fill: "url(#paint0_linear_454_108729)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_454_108729)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 291.33,
    cy: 425.387,
    rx: 291.33,
    ry: 425.387,
    transform: "matrix(0.697674 0.716415 -0.683113 0.730313 1333.62 -571)",
    fill: "url(#paint1_linear_454_108729)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_454_108729",
    x: 483.954,
    y: -343.038,
    width: 1263.53,
    height: 1302.84,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 138.558,
    result: "effect1_foregroundBlur_454_108729"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_454_108729",
    x: 614.641,
    y: -702.926,
    width: 1263.3,
    height: 1302.61,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 138.5,
    result: "effect1_foregroundBlur_454_108729"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_454_108729",
    x1: 291.33,
    y1: 0,
    x2: 291.33,
    y2: 850.774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22D695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22D695",
    stopOpacity: 0.59
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_454_108729",
    x1: 291.33,
    y1: 0,
    x2: 291.33,
    y2: 850.774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#434BEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#434BEE",
    stopOpacity: 0.59
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_454_108729"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1400,
    height: 400,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg8Desktop);
export default __webpack_public_path__ + "static/media/bg8-desktop.d7ddcf5b6905a2387027a119cd130ed1.svg";
export { ForwardRef as ReactComponent };